import { isString, merge } from 'lodash-es';
import { type PropsWithChildren, useContext } from 'react';

import { DEFAULT_HONEYCOMB_CONFIG } from '../constants.js';
import { HoneycombChartConfigContext } from '../context/honeycomb-chart-config.context.js';
import { HoneycombRequiredConfigProps } from '../types/honeycomb-internal.js';
import { HoneycombChartProps } from '../types/honeycomb.js';
import { buildHoneycombConfig } from '../utils/build-honeycomb-config.js';
import { iterateHoneycombSlots } from '../utils/iterate-honeycomb-slots.js';

function deserializeConfig(contextConfig: string) {
  try {
    return merge({}, DEFAULT_HONEYCOMB_CONFIG, JSON.parse(contextConfig));
  } catch {
    return DEFAULT_HONEYCOMB_CONFIG;
  }
}

export const useHoneycombChartConfig = (
  props: PropsWithChildren<HoneycombChartProps>,
): HoneycombRequiredConfigProps => {
  const { children } = props;
  const contextConfig = useContext(HoneycombChartConfigContext);
  const slots = iterateHoneycombSlots(children);
  const config = isString(contextConfig)
    ? deserializeConfig(contextConfig)
    : contextConfig;

  return buildHoneycombConfig(props, config, slots);
};
